import React, { useEffect, useState } from "react";
import NavHeader from "../components/NavHeader";
import {
  Badge,
  Box,
  Button,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import cr from "../lib/request";
import NoData from "../components/NoData";
import ComponentSpinner from "../components/ComponentSpinner";
import { BlogPostList } from "../const/types";
import TambahBlogPostModal from "../components/blogComponents/TambahBlogPostModal";
import {
  ArrowRight,
  CirclesFour,
  Eye,
  MagnifyingGlass,
} from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { iconSize } from "../const/sizes";
import formatDate from "../lib/formatDate";
import formatNumberShort from "../lib/formatNumberShort";
import formatNumber from "../lib/formatNumber";

export default function BlogPost() {
  const [data, setData] = useState<BlogPostList[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    setLoading(true);
    const url = `api/blog/post/allpostlist`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <NavHeader backLink={"/blog"} label={"Blog Post"} />

      <HStack justify={"space-between"} p={5}>
        <InputGroup>
          <InputLeftElement>
            <Icon as={MagnifyingGlass} />
          </InputLeftElement>
          <Input
            maxW={"400px"}
            placeholder="Pencarian"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </InputGroup>

        <TambahBlogPostModal />

        <Button
          colorScheme="ap"
          variant={"outline"}
          as={Link}
          to={"/blog/post/restore"}
          rightIcon={<Icon as={ArrowRight} fontSize={iconSize} />}
          flexShrink={0}
        >
          Restore
        </Button>
      </HStack>

      {!loading && data && data.length > 0 ? (
        <VStack align={"stretch"} px={3} pb={5}>
          <SimpleGrid columns={[1, null, 2, 3, 4, 5]} gap={4}>
            {data.map((blog, i) => {
              const ok =
                blog.title.toLowerCase().includes(search.toLowerCase()) ||
                blog.description.toLowerCase().includes(search.toLowerCase()) ||
                blog.category_name
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                blog.id.toString().includes(search);

              return (
                ok && (
                  <Tooltip
                    key={i}
                    // label={blog.title}
                  >
                    <VStack
                      align={"stretch"}
                      as={Link}
                      to={`/blog/post/${blog.id}/edit`}
                      borderRadius={12}
                      p={2}
                      transition={"200ms"}
                      cursor={"pointer"}
                      _hover={{
                        boxShadow: "0 0 0 1px var(--divider2))",
                        bg: "var(--divider)",
                        // border: "1px solid var(--divider3)",
                      }}
                      className="clicky"
                      gap={0}
                    >
                      <Box
                        bgImage={`${process.env.REACT_APP_MEDIA_BASE_URL}${blog.image}`}
                        bgSize={"cover"}
                        bgPos={"center"}
                        h={"200px"}
                        borderRadius={8}
                        mb={2}
                      />

                      <VStack p={2} align={"stretch"} flex={1} gap={0}>
                        <HStack justify={"space-between"} mb={3}>
                          <Badge bg={"var(--divider2)"} pl={3}>
                            <HStack>
                              <Icon as={CirclesFour} fontSize={16} />
                              <Text fontSize={12}>{blog.category_name}</Text>
                            </HStack>
                          </Badge>

                          <Tooltip label={`${formatNumber(blog.views)} views`}>
                            <HStack opacity={0.5}>
                              <Icon as={Eye} fontSize={16} />

                              <Text noOfLines={1}>
                                {formatNumberShort(blog.views)}
                              </Text>
                            </HStack>
                          </Tooltip>
                        </HStack>

                        <Text
                          fontSize={[20, null, 22]}
                          fontWeight={700}
                          noOfLines={2}
                          mb={4}
                          lineHeight={1.4}
                        >
                          {blog.title}
                        </Text>

                        <Text
                          noOfLines={2}
                          mb={4}
                          lineHeight={1.4}
                          opacity={0.5}
                        >
                          {blog.description}
                        </Text>

                        <HStack
                          justify={"space-between"}
                          mt={"auto"}
                          align={"flex-end"}
                        >
                          <Badge
                            colorScheme={blog.online_status ? "green" : "red"}
                          >
                            {blog.online_status ? "Online" : "Offline"}
                          </Badge>

                          <VStack align={"flex-end"} gap={0}>
                            <Text fontSize={"small"} opacity={0.5}>
                              Terakhir diperbarui
                            </Text>
                            <Text>{`${formatDate(blog.updated_at)}`}</Text>
                          </VStack>
                        </HStack>

                        {/* <Text color={"p.500"}>Klik untuk kelola</Text> */}
                      </VStack>
                    </VStack>
                  </Tooltip>
                )
              );
            })}
          </SimpleGrid>
        </VStack>
      ) : !loading && data && data.length === 0 ? (
        <NoData />
      ) : (
        <ComponentSpinner flex={1} />
      )}
    </>
  );
}
